<template>
    <b-container class="my-habits-rating-slider">

        <div class="my-habits-rating-slider__slider"
             ref="slider"></div>

        <div class="my-habits-rating-slider__value">
            <span class="my-habits-rating-slider__value-value">
                {{ currentValue }} {{ $i18n.gt('LABEL_MY_HABITS_OUT_OF_10)') }}
            </span>
        </div>
    </b-container>
</template>

<!-- ----------------------------------------------------------------------- -->

<script>
    import Vue from 'vue'
    import noUiSlider from 'nouislider'

    /**
     * Slider for rating motivation or progress properties for a wellness Habit
     */
    export default Vue.extend({
        name: 'MyHabitsRatingSlider',
        props: {
            uid: String,         // unique ID to use in the DOM ID of the slider element
            value: Number,
            disabled: Boolean,
            onUpdate: Function,  // callback to store the updated values when the slider is moved
        },
        data() {
            return {
                sliderElt: null,
                slider: null,
                currentValue: this.value
            }
        },
        mounted() {
            const vm = this

            this.sliderElt = this.$refs['slider']

            // initialize slider
            vm.slider = noUiSlider.create(this.sliderElt, {
                start: vm.value,
                step: 1,
                range: {
                    min: 1,
                    max: 10
                }
            });

            // handle slider updates
            this.sliderElt.noUiSlider.on('update', function (values, handle) {
                // console.log(values, handle)
                let val = parseInt(values[0])

                if (val == 0) {
                    val = null
                }

                vm.currentValue = val

                if (vm.onUpdate) {
                    vm.onUpdate(vm.uid, val)
                }
            });

        },

    })
</script>

<!-- ----------------------------------------------------------------------- -->

<style lang="scss">

    @import '../../node_modules/nouislider/distribute/nouislider.css';

    .my-habits-rating-slider {

        padding-right: 30px;
        
        // noUiSlider overrides

        .noUi-handle {
            height: 24px;
            width: 20px;
        }

        .noUi-horizontal {
            height: 14px;
        }

        .noUi-pips {
            display: none;
        }

        .noUi-handle::before {
            left: 7px;
            top: 6px;
            height: 10px;
        }

        .noUi-handle::after {
            left: 11px;
            top: 6px;
            height: 10px;
        }
    }

    .my-habits-rating-slider__slider {
        margin: 0;
    }

    .my-habits-rating-slider__value {
        text-align: center;
        margin-top: 10px;
    }

    .my-habits-rating-slider__value-value {
        font-weight: bold;
    }

</style>

